import { OktaMetaData } from 'module/api/account/types';
import { API_HOST, API_NAMESPACE, API_VERSION } from 'config/environment';

export const useCognitoAuth = ({
  oktaMetaData,
}: {
  oktaMetaData?: OktaMetaData;
}) => {
  const idpId = oktaMetaData?.idps?.find((idp) => idp.enabled)?.idpId;

  const generateRandomString = (length: number) => {
    const result: string[] = [];
    const characters =
      'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const charactersLength = characters.length;

    for (let i = 0; i < length; i += 1) {
      result.push(
        characters.charAt(Math.floor(Math.random() * charactersLength)),
      );
    }

    return result.join('');
  };

  function base64UrlEncode(buffer) {
    return btoa(String.fromCharCode(...new Uint8Array(buffer)))
      .replace(/\+/g, '-')
      .replace(/\//g, '_')
      .replace(/=+$/, '');
  }

  // Function to get the SHA-256 digest of a given input
  async function sha256Digest(input) {
    const encoder = new TextEncoder();
    const _data = encoder.encode(input);

    return crypto.subtle.digest('SHA-256', _data);
  }

  const samlFlowHandler = async () => {
    const clientId = oktaMetaData?.clientId;
    const issuerDomain = oktaMetaData?.issuerDomain;
    const responseType = 'code';
    const scope = 'openid profile email';
    const state = generateRandomString(64);
    const nounce = generateRandomString(64);
    const _codeVerifier: string = generateRandomString(43);

    sessionStorage.setItem('codeVerifier', _codeVerifier);

    const codeChallenge = base64UrlEncode(await sha256Digest(_codeVerifier));
    const codeChallengeMethod = 'S256';
    const redirectUri = `${window.location.origin}/implicit/callback`;

    const params = new URLSearchParams({
      client_id: clientId || '',
      redirect_uri: redirectUri,
      issuer: issuerDomain || '',
      idp: idpId || '',
      response_type: responseType,
      scope,
      state,
      nounce,
      code_challenge: codeChallenge,
      code_challenge_method: codeChallengeMethod,
    });

    window.location.href = `${issuerDomain}/oauth2/authorize?${params.toString()}`;
  };

  const googleSSOHandler = () => {
    const BASEURL = `${API_HOST}/${API_NAMESPACE}/${API_VERSION}`;

    window.location.href = `${BASEURL}/google/oauth2/initiate`;
  };

  return { samlFlowHandler, googleSSOHandler };
};
